/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faint_Jade_Trout_PurrInputs */

const en_faint_jade_trout_purr = /** @type {(inputs: Faint_Jade_Trout_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delayed`)
};

const de_faint_jade_trout_purr = /** @type {(inputs: Faint_Jade_Trout_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzögert`)
};

/**
* | output |
* | --- |
* | "Delayed" |
*
* @param {Faint_Jade_Trout_PurrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faint_jade_trout_purr = /** @type {((inputs?: Faint_Jade_Trout_PurrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faint_Jade_Trout_PurrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faint_jade_trout_purr(inputs)
	return de_faint_jade_trout_purr(inputs)
});